import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";

import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";

import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import {
  FamilyMemberModel,
  FamilyModel,
} from "../brother-attribution-models/family-model";
import { BrotherAttributionFamilyEditorComponent } from "../brother-attribution-family-editor/brother-attribution-family-editor.component";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { BrotherAttributionService } from "../../../_services/brother-attribution.service";

@Component({
  selector: "family-edit-form",
  templateUrl: "./family-edit-form.component.html",
  styleUrls: [
    "../family-creation-form/family-creation-form.component.scss",
    "./family-edit-form.component.scss",
  ],
})
export class FamilyEditFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();

  @ViewChild("familyEditorComponent")
  public familyEditorComponent!: BrotherAttributionFamilyEditorComponent;

  public disableSave: boolean = true;
  public translations$: Observable<ITranslations>;
  private familyStatus: Array<
    FamilyMemberModel & { status: "new" | "exiting" | "deleted" }
  > = [];

  constructor(
    protected dataService: DataService,
    protected authenticationService: AuthenticationService,
    private brotherAttributionService: BrotherAttributionService,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef,
    protected translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  @Input("familyToEdit")
  public set familyToEdit(value: FamilyModel) {
    this.familyStatus = value.members.map((member) => ({
      ...member,
      status: "exiting" as any,
    }));

    this.familyEditorComponent.familyToEdit = this.familyStatus;
  }

  public ngOnInit(): void {}

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {}

  public areChangesValid() {
    const areSomeOriginalMembersExist = this.familyStatus.some(
      (f) => f.status === "exiting"
    );
    const areSomeNewMembersExist = this.familyStatus.some(
      (f) => f.status === "new"
    );
    if (!areSomeOriginalMembersExist && areSomeNewMembersExist) {
      const modalText = "לא ניתן להוסיף אחים חדשים ללא אחים קיימים";
      this.modalNotification(modalText, false).then();
      return false;
    }
    return true;
  }

  public async saveChanges(number: number) {
    if (!this.areChangesValid()) {
      return;
    }
    const dataForPostAction = this.familyStatus.map((f) => ({
      id: f.id.toString(),
      status: f.status,
    }));
    const saveResult = await this.brotherAttributionService.saveFamilyChanges(
      dataForPostAction
    );

    if (saveResult.success === false) {
      await this.modalNotification(
        this.translationService.currentTranslations.general_error +
          " " +
          saveResult.error.toString()
      );
      return;
    }

    const startText = "השינויים בשיוך בוצעו בהצלחה:";
    const allMembers = this.familyStatus.map((f) => {
      let status = "נשאר בשיוך";
      if (f.status === "new") {
        status = "נוסף לשיוך";
      } else if (f.status === "deleted") {
        status = "הוסר מהשיוך";
      }
      return `    • ${f.firstName} ${f.lastName} - ${status}\n`;
    });

    this.modalNotification(`${startText}\n${allMembers.join("")}`).then();
  }

  public async closeParentEventModal() {
    this.modalAction.emit("close");
  }

  public updateFamilyStatus(
    $event: Array<FamilyMemberModel & { status: "new" | "exiting" | "deleted" }>
  ) {
    this.familyStatus = $event;

    this.disableSave = this.familyStatus.length <= 1;
  }

  protected handleError(err: any) {
    const isDisconnected = err.status === 401;
    const noUserPermission = err.status === 400;
    let modalText = err.toString();
    if (noUserPermission) {
      modalText = `אין לך הרשאה מספקת לערוך  `;
    } else if (isDisconnected) {
      modalText = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {
      this.closeParentEventModal().then((r) => r);
      if (isDisconnected) {
        setTimeout(() => this.router.navigate(["/login"]), 1000);
      }
    });
  }

  protected async modalNotification(
    message: string,
    closeParentEventModal = true
  ) {
    let modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שיוך אחים ואחיות",
      modalText,
      onlyApprove: true,
      customTextStyle: {
        "white-space": "pre-wrap",
        textAlign: "start",
        direction: "rtl",
        paddingRight: "40px",
      },
    };
    await modalRef.result;
    if (closeParentEventModal) {
      await this.closeParentEventModal();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/family-edit-form/family-edit-form.component.ts